import { Component , OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../_services/index';
import { FormBuilder, FormGroup } from '@angular/forms';
import 'rxjs/add/operator/map'
import * as _ from 'underscore';
import { LoaderService } from 'app/_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import { environment } from 'environments/environment';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import {GridDataResult,DataStateChangeEvent} from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs/Observable'; 
import { ExcelExportData } from '@progress/kendo-angular-excel-export';

declare var $: any;

import { UccUsersService } from '../../reports/uccReport/uccUsers.service';
import { UccPermsService } from './UccPerms.service';
import { uccUsers } from '../../reports/uccReport/uccUsers.model';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { getDatabase, ref, onValue} from "firebase/database";
import { utils, write, WorkBook } from 'xlsx';


import * as XLSX from 'xlsx';

import { saveAs } from 'file-saver';
import { forEach } from 'lodash';


declare var firebase: any;

@Component({
    selector: 'vts-status',
    templateUrl: './ipWhitlist.component.html',
})

export class ipWhitlistComponent {

    
   

     public prjId:any;
     public id: string;


     public clientName :any;
     public IP :any;
     public status :boolean;
     public Apiname :any;


     public e_clientName = false  ;
     public e_IP = false ;
     public e_status  = false ;
     public e_Apiname  = false ;
     clientList: { ID: string; VALUE: string; }[];
     statusList: { ID: number; VALUE: string; }[];
  allWhiteListData: Object;
  success: any;

      


  

    constructor(private fb: FormBuilder,private http: HttpClient, private auth: AuthService, public afs: AngularFirestore){
      
     
      this.clientList = [
        { "ID": "GMDA", "VALUE": "GMDA" }, 
        { "ID": "MCG", "VALUE": "MCG" },
        { "ID": "HIPA", "VALUE": "HIPA" },
      ]


      this.statusList = [
        { "ID": 1, "VALUE": "WhiteList" }, 
        { "ID": 0, "VALUE": "BlockList" },
       
      ]
    }

    ngOnInit() {

    this.prjId = this.auth.getAuthentication().projectId
    this.id = this.auth.getAuthentication().id;

  
    this.getAllWhitelistData()

   

    
 

    }

    newIP(){
        $('#NewUserModal').modal('show');
    }


    createNewIp(){


      console.log( '110',this.status);


  

      if (this.clientName == null || this.clientName == undefined || this.clientName == "" || this.clientName == "null") {
        this.e_clientName = true;
        return;
      } else {
        this.e_clientName = false;
      }


      if (this.IP == null || this.IP == undefined || this.IP == "" || this.IP == "null") {
        this.e_IP = true;
        return;
      } else {
        this.e_IP = false;
      }


      
      if (this.status == null || this.status == undefined ) {
        this.e_status = true;
        return;
      } else {
        this.e_status = false;
      }

         
      if (this.Apiname == null || this.Apiname == undefined || this.Apiname == "" || this.Apiname == "null") {
        this.e_Apiname = true;
        return;
      } else {
        this.e_Apiname = false;
      }






      var jsonAddData = {
        "clentname":this.clientName,
        "IP": this.IP,
        "status": this.status ,
        "apiName":  this.Apiname,
        "prjid" : this.prjId
        
      }


      console.log(jsonAddData);
      


       this.http.post(environment.apiUrl + 'reports/saveIPForClient', jsonAddData).subscribe((data)=>{

         

        this.getAllWhitelistData();
    

        setTimeout(() => {
          $("#NewUserModal").modal("hide");
            this.editmessage()
           }, 10000
        );
        this.clearAllField();
          

       })  
    }



    getAllWhitelistData(){

      console.log('172',environment.apiUrl + 'reports/getIPForClient?prjid='+this.prjId );
      

      this.http.get(environment.apiUrl + 'reports/getIPForClient?prjid='+this.prjId ).subscribe((data)=>{

         
           this.allWhiteListData =  data


           console.log(this.allWhiteListData);
           

          

      })  

    }

    clearAllField(){

      this.clientName = null,
      this.IP  = null,
      this.status  = null,
      this.Apiname = null,
      this.prjId   = null 

      this.success = false

    }


    editmessage(){


      this.success = true ;
    }






    









}






// WEBPACK FOOTER //
// ./src/app/superAdmin/users/ipWhitlist.component.ts